module.exports = __webpack_public_path__ + "static/media/resume.0ede9042.pdf";